// generate-share-manifest.mjs가 생성한다. 이미지 변경 후 다시 생성한다.
export const shareImages = {
  "/characters/female/share-preview.png": "7a3acb6db70736668fbbf2b9c0b3def1abbed2c1f1cdfaaf5ff494fe43f6aad7",
  "/characters/male/share-preview.png": "73313814577aa337de0db1a61e689d27fd0ef1982a686f67b8c3190a422e8395",
  "/characters/duet/share-preview.png": "f75c3dcecb828759fcf284e07deeb38cbe11e0e0d9111ee4bdb40cef6096841c",
  "/promotionViewTitle_resize.png": "167109cdf6c063b1041c69bb8cba7cd53b1223da9d5c1279364e6ad7b86a42b8"
};
export const shareImageDimensions = {
  "/characters/female/share-preview.png": {
    "width": 1200,
    "height": 628
  },
  "/characters/male/share-preview.png": {
    "width": 1200,
    "height": 630
  },
  "/characters/duet/share-preview.png": {
    "width": 1200,
    "height": 629
  },
  "/promotionViewTitle_resize.png": {
    "width": 752,
    "height": 501
  }
};
